import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Swal from "sweetalert2";
import Header from "components/Headers/Header";
import { useSessionStore } from "../../stores/sessionStore";
import { useSettingStore } from "../../stores/settingStore";
import { api } from "../../config/middleware";
import { API_GETSETTING } from "../../config/api";

const Marketplace = () => {
  const sa = {
    info: (text, title = "แจ้งเตือน") =>
      Swal.fire({ icon: "info", title, text, confirmButtonText: "ตกลง" }),
    success: (text, title = "สำเร็จ") =>
      Swal.fire({ icon: "success", title, text, confirmButtonText: "ตกลง" }),
    error: (text, title = "เกิดข้อผิดพลาด") =>
      Swal.fire({ icon: "error", title, text, confirmButtonText: "ปิด" }),
  };

  const orgId = useSessionStore((s) => s.profile?.orgId);
  const tnId = useSessionStore((s) => s.profile?.tnId);
  const brId = useSessionStore((s) => s.profile?.brId);

  const setBillMode = useSettingStore((s) => s.setBillMode);

  useEffect(() => {
    const fetchSetting = async () => {
      const res = await api.get(API_GETSETTING, {
        params: { TNID: tnId, ORGID: orgId, BRID: brId },
      });

      if (res.data?.statustext === "SUCCESS") {
        setBillMode(res.data.data.billMode);
      }
    };

    if (tnId != null && orgId != null && brId != null) {
      fetchSetting();
    }
  }, [tnId, orgId, brId, setBillMode]);

  // ---------- Tabs ----------
  const [activeTab, setActiveTab] = useState("laundry"); // "laundry" | "package"

  // ✅ Favorites: เก็บ id ของการ์ดที่ถูกกดหัวใจ
  const [favorites, setFavorites] = useState(() => new Set());

  const toggleFavorite = (id) => {
    setFavorites((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  // ✅ mock data (ของจริงคุณจะเปลี่ยนเป็น servicePkgs ได้)
  const cards = useMemo(
    () => [
      {
        id: 1,
        title: "แพ็คเกจ 1",
        desc: "Just another contact form plugin. Simple but flexible.",
        btnText: "ซื้อเลย",
        rating: 4,
        reviews: 1969,
        updatedText: "อัปเดตล่าสุด 6 วันที่แล้ว",
        logoText: "CF",
      },
      {
        id: 2,
        title: "แพ็คเกจ 2",
        desc: "Just another contact form plugin. Simple but flexible.",
        btnText: "ซื้อเลย",
        rating: 4,
        reviews: 1969,
        updatedText: "อัปเดตล่าสุด 6 วันที่แล้ว",
        logoText: "CF",
      },
      {
        id: 3,
        title: "แพ็คเกจ 3",
        desc: "Just another contact form plugin. Simple but flexible.",
        btnText: "ซื้อเลย",
        rating: 4,
        reviews: 1969,
        updatedText: "อัปเดตล่าสุด 6 วันที่แล้ว",
        logoText: "CF",
      },
      {
        id: 4,
        title: "แพ็คเกจ 4",
        desc: "Just another contact form plugin. Simple but flexible.",
        btnText: "ซื้อเลย",
        rating: 4,
        reviews: 1969,
        updatedText: "อัปเดตล่าสุด 6 วันที่แล้ว",
        logoText: "CF",
      },
      {
        id: 5,
        title: "แพ็คเกจ 5",
        desc: "Just another contact form plugin. Simple but flexible.",
        btnText: "ซื้อเลย",
        rating: 4,
        reviews: 1969,
        updatedText: "อัปเดตล่าสุด 6 วันที่แล้ว",
        logoText: "CF",
      },
      {
        id: 6,
        title: "แพ็คเกจ 6",
        desc: "Just another contact form plugin. Simple but flexible.",
        btnText: "ซื้อเลย",
        rating: 4,
        reviews: 1969,
        updatedText: "อัปเดตล่าสุด 6 วันที่แล้ว",
        logoText: "CF",
      },
    ],
    [],
  );

  // ✅ แท็บรายการโปรด: filter เฉพาะที่อยู่ใน favorites
  const cardsToShow = useMemo(() => {
    if (activeTab === "package") {
      return cards.filter((c) => favorites.has(c.id));
    }
    return cards; // ขายดีที่สุด
  }, [activeTab, cards, favorites]);

  const StarRow = ({ rating, reviews }) => (
    <div className="wp-stars" title="rating">
      {"★".repeat(Math.max(0, Math.min(5, rating)))}
      {"☆".repeat(Math.max(0, 5 - Math.max(0, Math.min(5, rating))))}
      <small>({Number(reviews || 0).toLocaleString()})</small>
    </div>
  );

  return (
    <>
      <style>{`
.wp-grid {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr)); /* desktop = 4 */
  gap: 14px;
}

/* จอกลาง */
@media (max-width: 1199px) {
  .wp-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)); /* 2 */
  }
}

/* จอเล็ก */
@media (max-width: 767px) {
  .wp-grid {
    grid-template-columns: 1fr; /* 1 */
  }
}

.wp-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}

/* ✅ แก้ตรงนี้: action column ใช้ auto ไม่ fix 170px */
.wp-card-top {
  padding: 14px 14px 12px 14px;
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr) auto;
  gap: 14px;
  align-items: start;
}

.wp-logo {
  width: 84px;
  height: 84px;
  border-radius: 8px;
  background: #f1f5f9;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-weight: 800;
}

/* ✅ ช่วยกันข้อความโดนบีบ */
.wp-info {
  min-width: 0; /* สำคัญมากกับ grid */
}

.wp-title {
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 6px;
  font-size: 16px;
}

/* ✅ ทำให้คำอธิบายดูสวย ไม่หดเป็นเส้นยาว */
.wp-desc {
  font-size: 13px;
  color: #475569;
  line-height: 1.35;
  margin-bottom: 6px;
  display: -webkit-box;
  -webkit-line-clamp: 2;     /* แสดง 2 บรรทัด */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.wp-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  min-width: 110px; /* กันปุ่มหาย */
}

.wp-btn {
  height: 34px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #0f172a;
  font-size: 13px;
  padding: 0 12px;
  font-weight: 600;
  white-space: nowrap; /* กันคำขึ้นบรรทัด */
}

.wp-btn.primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.wp-link {
  font-size: 12px;
  color: #2563eb;
  cursor: pointer;
  user-select: none;
}

/* ✅ แถวล่าง: ดาวซ้าย / หัวใจขวา */
.wp-card-bottom {
  padding: 10px 14px;
  background: #f8fafc;
  border-top: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between; /* ⭐ .... ❤️ */
  gap: 10px;
}

.wp-stars {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #f59e0b;
  font-size: 14px;
}
.wp-stars small {
  color: #64748b;
  font-size: 12px;
}

/* ✅ Heart (อยู่ตำแหน่งที่วง) */
.wp-heart {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.08);
  flex: 0 0 auto;
}
.wp-heart:hover {
  transform: translateY(-1px);
}
.wp-heart i {
  font-size: 16px;
}

/* ✅ ถ้าจอแคบมาก ให้ปุ่มเต็มความกว้างและ actions ลงบรรทัด */
@media (max-width: 420px) {
  .wp-card-top {
    grid-template-columns: 84px minmax(0, 1fr);
    grid-auto-rows: auto;
  }
  .wp-actions {
    grid-column: 1 / -1;
    align-items: stretch;
  }
  .wp-btn {
    width: 100%;
  }
}
  /* ✅ กันภาษาไทยแตกเป็นตัว ๆ / ตัดคำเพี้ยน */
.wp-title,
.wp-desc {
  word-break: keep-all;        /* พยายามไม่ตัดคำมั่ว */
  overflow-wrap: anywhere;     /* ถ้าจำเป็นค่อยตัด แต่ไม่ทำให้ตัวอักษรแตก */
}

/* ✅ tablet range: ให้ action ลงแถวล่าง เพื่อให้ title มีพื้นที่ */
@media (max-width: 1399px) and (min-width: 992px) {
  .wp-card-top {
    grid-template-columns: 84px minmax(0, 1fr);
  }

  .wp-actions {
    grid-column: 1 / -1;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    margin-top: 6px;
    min-width: 0;
  }

  .wp-btn {
    width: auto;
  }
}

/* ✅ เพิ่ม: กัน title โดนบีบจนแคบมาก */
.wp-info {
  min-width: 0;
}
`}</style>

      <div className="order-page">
        <Header />
        <Container className="mt--7" fluid>
          <Card>
            <Nav tabs className="mt-3">
              <NavItem>
                <NavLink
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab("laundry");
                  }}
                  className={activeTab === "laundry" ? "active" : ""}
                >
                  ขายดีที่สุด
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab("package");
                  }}
                  className={activeTab === "package" ? "active" : ""}
                >
                  รายการโปรด ({favorites.size})
                </NavLink>
              </NavItem>
            </Nav>

            <CardBody
              className="border-0 p-2 p-lg-4"
              style={{ backgroundColor: "#f7f9fb" }}
            >
              <Row className="g-0 px-0">
                <Col xs="12" md="12" lg="12" className="mb-3 px-0 px-lg-2">
                  <Card className="shadow-sm h-100">
                    <CardBody style={{ padding: "1rem" }}>
                      <div className="wp-grid">
                        {cardsToShow.length === 0 && activeTab === "package" ? (
                          <div
                            style={{
                              gridColumn: "1 / -1",
                              padding: 16,
                              color: "#64748b",
                              textAlign: "center",
                            }}
                          >
                            ยังไม่มีรายการโปรด
                          </div>
                        ) : (
                          cardsToShow.map((p) => {
                            const fav = favorites.has(p.id);

                            return (
                              <div key={p.id} className="wp-card">
                                <div className="wp-card-top">
                                  <div className="wp-logo">{p.logoText}</div>

                                  {/* ✅ เพิ่ม class wp-info */}
                                  <div className="wp-info">
                                    <div className="wp-title">{p.title}</div>
                                    <div className="wp-desc">{p.desc}</div>
                                  </div>

                                  <div className="wp-actions">
                                    <button
                                      type="button"
                                      className="wp-btn primary"
                                      onClick={() =>
                                        Swal.fire("Action", p.btnText, "info")
                                      }
                                    >
                                      {p.btnText}
                                    </button>
                                    <div
                                      className="wp-link"
                                      role="button"
                                      tabIndex={0}
                                      onClick={() =>
                                        Swal.fire("Details", p.title, "info")
                                      }
                                    >
                                      ดูรายละเอียด
                                    </div>
                                  </div>
                                </div>

                                {/* ✅ ดาวซ้าย / หัวใจขวา */}
                                <div className="wp-card-bottom">
                                  <StarRow
                                    rating={p.rating}
                                    reviews={p.reviews}
                                  />

                                  <button
                                    type="button"
                                    className="wp-heart"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      toggleFavorite(p.id);
                                    }}
                                    title={
                                      fav
                                        ? "ลบออกจากรายการโปรด"
                                        : "เพิ่มเป็นรายการโปรด"
                                    }
                                  >
                                    <i
                                      className="ni ni-favourite-28"
                                      style={{
                                        color: fav ? "#ef4444" : "#94a3b8",
                                      }}
                                    />
                                  </button>
                                </div>

                                <div
                                  style={{
                                    padding: "8px 14px",
                                    fontSize: 12,
                                    color: "#64748b",
                                    borderTop: "1px solid #e5e7eb",
                                    background: "#fff",
                                    textAlign: "right",
                                  }}
                                >
                                  {p.updatedText}
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default Marketplace;
